export default __webpack_public_path__ + "static/media/Group 116.1cb43ea2.svg";